import React, {Component} from "react"
import ReactDOM from "react-dom";

export class FreightTypeChoice extends Component{

    constructor(props){
        super(props);
    }
    componentDidMount(){
        this.props.onOriginPortChange(document.getElementById("Loading-Port-Select").value);
        this.props.onDestinationPortChange(document.getElementById("Destination-Port-Select").value);
    }
    render(){
        return(
            <div className="col-12 mb-3">
                <hr/>
                <label className="mb-1"><strong>Port details</strong></label>
                <div className="row mb-2">
                    <div className="col-md-4 col-sm-12 mt-2 mt-md-0"> 
                        <label className="control-label">Select Loading Port</label>                                                
                        <select id="Loading-Port-Select" name="loadingPort" className="form-select"
                            onChange={evt => this.props.onOriginPortChange(evt.target.value)}>
                            <option value="Baltimore, Maryland">Baltimore, Maryland</option>
                            <option value="Bayonne, New York">Bayonne, New York</option>
                            <option value="Boston, Massachusetts">Boston, Massachusetts</option>
                            <option value="Freeport, Texas">Freeport, Texas</option>
                            <option value="Galveston, Texas">Galveston, Texas</option>
                            <option value="Houston, Texas">Houston, Texas</option>
                            <option value="Jacksonville, Florida">Jacksonville, Florida</option>
                            <option value="Longbeach, California">Longbeach, California</option>
                            <option value="Oakland, California">Oakland, California</option>
                            <option value="Newark, New Jersey">Newark, New Jersey</option>
                            <option value="Philadelphia, Pennsylvania">Philadelphia, Pennsylvania</option>
                            <option value="Providence, Rhode Island">Providence, Rhode Island</option>
                            <option value="Savannah, Georgia">Savannah, Georgia</option>
                            <option value="Wilmington, Delaware">Wilmington, Delaware</option>
                        </select>
                    </div>
                    <div className="col-md-4 col-sm-12 mt-2 mt-md-0">
                        <label className="control-label">Select Destination Port</label>                        
                        <select id="Destination-Port-Select" name="destinationPort" className="form-select"
                            onChange={evt => this.props.onDestinationPortChange(evt.target.value)}>
                            <option value="Abidjan, Côte d'Ivoire">Abidjan, Côte d'Ivoire</option>
                            <option value="Banjul, The Gambia">Banjul, The Gambia</option>
                            <option value="Bata, Equatorial Guinea">Bata, Equatorial Guinea</option>
                            <option value="Conakry, Guinea">Conakry, Guinea</option>
                            <option value="Douala, Cameroon">Douala, Cameroon</option>
                            <option value="Freetown, Sierra Leone">Freetown, Sierra Leone</option>
                            <option value="Lagos, Nigeria">Lagos, Nigeria</option>
                            <option value="Libreville, Gabon">Libreville, Gabon</option>
                            <option value="Lome, Togo">Lome, Togo</option>
                            <option value="Luanda, Angola">Luanda, Angola</option>
                            <option value="Malabo, Equatorial Guinea">Malabo, Equatorial Guinea</option>
                            <option value="Monrovia, Liberia">Monrovia, Liberia</option>
                            <option value="Nouakchott, Mauritania">Nouakchott, Mauritania</option>
                            <option value="Onne PHC, Nigeria">Onne PHC, Nigeria</option>
                            <option value="Pointe Noire, Congo">Pointe Noire, Congo</option>
                            <option value="Tema, Ghana">Tema, Ghana</option>
                            <option value="Dakar, Senegal">Dakar, Senegal</option>
                        </select>
                    </div>                    
                    <div className="col-md-4 col-sm-12 mt-2 mt-md-0">
                        <label className="control-label">Preffered Vessels <br/><em>Select multiple with Ctrl+click (All selected by default)</em></label>                        
                        <select name="prefferedVessel" className="form-select" multiple>
                            <option value="Grimaldi" selected>Grimaldi</option>
                            <option value="Sallaum" selected>Sallaum</option>
                            <option value="MSC" selected>MSC</option>
                            <option value="Maersk" selected>Maersk</option>
                            <option value="Cosco" selected>Cosco</option>
                            <option value="CMA" selected>CMA CGM</option>
                        </select>
                    </div>
                </div>                
                <div className="col-12 mt-2 mt-md-0">
                    <label htmlFor="freightType" className="mb-1 mr-2"><strong>Are you moving vehicles or containers?</strong></label>                                                            
                    <div className="form-check form-check-inline">
                        <input type="radio" className="form-check-input" id="Moving-Vehicles" value="vehicle" name="freightType"
                            onClick={() => this.props.onChoiceChange("vehicle")}/>
                        <label className="form-check-label" htmlFor="Moving-Vehicles">
                            RoRo Vehicles
                        </label>
                    </div>
                    <div className="form-check form-check-inline">
                        <input type="radio" className="form-check-input" id="Moving-Containers" value="container" name="freightType"
                            onClick={() => this.props.onChoiceChange("container")}/>
                        <label className="form-check-label" htmlFor="Moving-Containers">
                            Containers
                        </label>
                    </div>
                </div>

            </div>
        )
    }

}